import Button from '@passkeys/ui/button';
import Logo from '@passkeys/ui/logo';
import Text from '@passkeys/ui/text';
import { useCallback } from 'react';

import exodus from '@/ui/exodus';
import { actions } from '@/ui/flux';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect';
import useNavigate from '@/ui/hooks/use-navigate';

type SwapUnavailableModalProps = {
  reason: string;
  onClose?: () => void;
};

const SwapUnavailableModal = ({
  reason,
  onClose,
}: SwapUnavailableModalProps) => {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate(-1);
    onClose?.();
  }, [navigate, onClose]);

  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'ExchangeTemporaryUnavailableView',
    });
  }, []);

  return (
    <div className="flex h-full flex-col pb-8">
      <div className="flex flex-1 flex-col items-center px-8">
        <div className="mb-6 flex h-[98px] w-[98px] items-center justify-center rounded-full bg-metallic-gradient">
          <div className="flex items-center justify-center rounded-full border border-pink-600 bg-pink-500 p-2">
            <Logo size={68} />
          </div>
        </div>

        <Text align="center" size={24} className="mb-4">
          {reason}
        </Text>

        <Text
          align="center"
          size={14}
          className="text-gray-600 theme-dark:text-neutral-200"
        >
          We're working hard to support more locations. Check back again in the
          future.
        </Text>
      </div>

      <Button
        size="large"
        onClick={handleClose}
        dataTestId="swap-unavailable-close-button"
      >
        Close
      </Button>
    </div>
  );
};

const showSwapUnavailableModal = async (reason: string) =>
  actions.modal.show({
    reactContent: <SwapUnavailableModal reason={reason} />,
    fullscreen: true,
    canClose: false,
  });

export default showSwapUnavailableModal;
